import React from 'react';

import { DropdownButton } from '@minecraft.molecules';
import { useTranslation } from '../I18N';
import { MediaUploader } from './MediaUploader';

type MediaUploadMenuProps = Omit<React.ComponentProps<typeof MediaUploader>, 'renderChildren'> & {
  canSelectFromMediaBank?: boolean;
  canUpload?: boolean;
  inactive?: boolean;
  label?: string;
  block?: boolean;
  onSelectFromMediaBank: () => void;
};

export const MediaUploaderMenu = ({
  canSelectFromMediaBank = true,
  canUpload = true,
  inactive = false,
  label,
  block = false,
  onSelectFromMediaBank,
  ...uploaderProps
}: MediaUploadMenuProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <MediaUploader
      {...uploaderProps}
      renderChildren={({ toggleModal }) => (
        <DropdownButton
          block={block}
          testId="media-upload-menu"
          toggleProps={{
            disabled: inactive || (!canSelectFromMediaBank && !canUpload),
            fixedWidth: false,
            isSecondary: true,
            block,
          }}
          toggleLabel={label ?? t(`common:mediaHelper.${uploaderProps.mediaType.toLowerCase()}.add`)}
          menuItemsProps={[
            {
              'data-testid': 'media-upload-menu-selectFromMediaLibrary',
              disabled: inactive || !canSelectFromMediaBank,
              id: 'media-upload-menu-selectFromMediaLibrary',
              label: t('common:media.upload.selectFromMediaLibrary'),
              onClick: () => onSelectFromMediaBank(),
            },
            {
              'data-testid': 'media-upload-menu-selectFromDevice',
              disabled: inactive || !canUpload,
              id: 'media-upload-menu-selectFromDevice',
              label: t('common:media.upload.selectFromDevice'),
              onClick: () => toggleModal(),
            },
          ]}
        />
      )}
    />
  );
};
